import Alpine from 'alpinejs'
import { formHandler } from './components/formHandler';

window.Alpine = Alpine

const { default: ToastManager } = require('./classess/ToastManager')

require('./ro')

require('./base/prototypes')
require('./base/namespace')
require('./base/modals-extension')
require('./base/preventEvent')

// Must be required before main scripts
require('./components/forms/no-submitter')

require('./api/live-search')
require('./api/reset-password')
require('./api/restore-password')
require('./api/sign-in')
require('./api/sign-up')
require('./api/vote-history-chart')
require('./api/vote-menu')
require('./api/cooldown-action')
require('./api/modal-vote-form')
require('./api/user-profile')

require('./components/accordion')
require('./components/avatar-upload-tools')
require('./components/all-tags-modal')
require('./components/button-allowance')
require('./components/about-server-comment-reply')
require('./components/content-switcher')
require('./components/control-wrapper')
require('./components/copy-link')
require('./components/drop-down')
require('./components/dynamic-text')
require('./components/image-picker')
require('./components/header')
require('./components/mouse-drag')
require('./components/rating-control')
require('./components/password-input-switcher')
require('./components/scrollable-with-hiders')
require('./components/tabs')
require('./components/complex-tooltip')
require('./components/announce-servers-toggling')

require('./components/forms/add-link')
require('./components/forms/js-calculate-with-discount')
require('./components/forms/js-buy-vip')
require('./components/forms/js-buy-banner')
require('./components/forms/js-buy-votes-form')

require('./plugins/airdatepicker')
require('./plugins/lazyLoadPicture')

window.ToastManager = new ToastManager({
    toastLifespan: 7000,
    topOffset: 30,
    spaceBetweenToasts: 10,
    toastTransition: .7
})

document.addEventListener('alpine:init', () => {
    Alpine.data('formHandler', formHandler)
})

Alpine.start()